import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const [credentials, setCredentials] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await axios.post(`${API}/auth/login`, credentials);
      localStorage.setItem('adminToken', response.data.access_token);
      navigate('/admin/dashboard');
    } catch (err) {
      setError('Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    backgroundColor: 'transparent',
    color: 'var(--text-primary)',
    borderColor: 'var(--border-strong)',
    fontFamily: 'Nohemi, sans-serif',
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ backgroundColor: 'var(--bg-secondary)' }} data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="p-12 border-2" style={{ backgroundColor: 'var(--card-bg)', borderColor: 'var(--border-strong)' }}>
          <h1
            className="text-3xl font-bold mb-8 text-center"
            style={{ color: 'var(--text-primary)', fontFamily: 'Nohemi, sans-serif' }}
          >
            Admin Login
          </h1>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-semibold mb-2" style={{ color: 'var(--text-primary)', fontFamily: 'Nohemi, sans-serif' }}>
                Email
              </label>
              <input
                type="email"
                value={credentials.email}
                onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
                required
                className="w-full px-4 py-3 text-base border-2 focus:outline-none transition-colors"
                style={inputStyle}
                data-testid="admin-email-input"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold mb-2" style={{ color: 'var(--text-primary)', fontFamily: 'Nohemi, sans-serif' }}>
                Password
              </label>
              <input
                type="password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                required
                className="w-full px-4 py-3 text-base border-2 focus:outline-none transition-colors"
                style={inputStyle}
                data-testid="admin-password-input"
              />
            </div>

            {error && (
              <div className="bg-red-50 text-red-800 dark:bg-red-900/20 dark:text-red-400 p-4" data-testid="admin-login-error">
                <p className="text-sm">{error}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full px-8 py-4 text-base font-bold uppercase tracking-wide transition-all duration-300 hover:opacity-80 disabled:opacity-50"
              style={{
                backgroundColor: 'var(--text-primary)',
                color: 'var(--bg-primary)',
                fontFamily: 'Nohemi, sans-serif',
              }}
              data-testid="admin-login-button"
              data-cursor-hover
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
